import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { Board } from '../../../core/board/board';
import { BoardService } from '../../../core/board/board.service';
import { BoardIconTitleComponent } from '../../board/board-icon-title/board-icon-title.component';

@Component({
  selector: 'app-add-member-btn',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzCollapseModule,
    NzProgressModule,
    NzSkeletonModule,
    NzPopoverModule,
    NzListModule,
    NzDropDownModule,

    MatTooltip,

    BoardIconTitleComponent,
  ],
  templateUrl: './add-member-btn.component.html',
  styleUrl: './add-member-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddMemberBtnComponent {
  isMemberListVisible = false;

  userList = toSignal(this.boardService.getAllUserList$(), { initialValue: [] });

  @Output() memberChange = new EventEmitter<Board>();

  constructor(private boardService: BoardService) {}

  onMemberClick(member: Board) {
    this.memberChange.emit(member);
  }
}
